import React from "react";
import translate from "../../../i18n/translate";
import "./ProgressPage.scss";
import { Card, CardContent } from "@material-ui/core";
import ProgressBar from "./ProgressBar";
import { getRandomNumber } from "../../shared/utils/sharedUtils";

const ProgressCard = (props: any) => {
  const { courseUnit, sessionCard, percentagePartCompleted, percentagePartLabel } = props;
  return (
    <React.Fragment>
      { !courseUnit ? 
        <Card>
          <CardContent>
            <div className="level-main-card">
              { sessionCard ? 
                <div className="session-completion">{ percentagePartCompleted }</div>
              : 
                <div className="completion-number">{ percentagePartCompleted }%</div>
              }
            <div className="completion-label completed-text">{translate(percentagePartLabel)}</div>
            </div>
          </CardContent>
        </Card>
      : <>
        { courseUnit.type && courseUnit.type === "digital_test" ? 
          <Card className="subskill-card">
            <CardContent>
              <div className="subskill-content-container">
                <div className="subskill-list-body competence">
                  <div className="subskill-progress-block">
                    <div className="competence-list">
                    { courseUnit?.competenceList?.length ? 
                    <>
                      {courseUnit?.competenceList?.length && courseUnit?.competenceList.map((competence: any, index: number) => {
                        return (
                          <div key={getRandomNumber(index)} className="subskill-progress-block-1 unit-progress-container">
                            <div className="subskill-progress-label">{ competence.competenceTitle }</div>
                            <div className="subskill-progress-bar">
                                <ProgressBar progressPercentage = { competence.competencePercentage ? competence.competencePercentage : 0}></ProgressBar>
                            </div>
                            <div className="competence-percentage">{ competence.competencePercentage ? competence.competencePercentage : 0}%</div>
                          </div>
                        )})
                      }
                    </>
                    :
                    <>
                      <div className="subskill-progress-block-1 unit-progress-container">
                        <div className="subskill-progress-bar">
                            <ProgressBar progressPercentage={0}></ProgressBar>
                        </div>
                        <div className="competence-percentage">0%</div>
                      </div>
                    </>
                    } 
                    </div>
                  </div>
                  <div className="unit-details-progress">
                    <div>{ translate("progress_testresults_table_scores")}</div>
                    <h4 className="MuiTypography-root MuiTypography-h4">{ courseUnit.competenceTotalPercentage }%</h4>
                  </div>                                               
                </div>
              </div>
              </CardContent>
          </Card> 
        : 
          <Card className="subskill-card">
            <CardContent>
              <div className="subskill-content-container">
                <div className="subskill-title">{courseUnit.title}</div>
                <div className="subskill-list-body">
                  <div className={`subskill-progress-block ${sessionCard ? 'unit-details-wrap' : ''}`}>
                    <div className="subskill-progress-block-1 unit-progress-container">
                      { sessionCard ?
                        <div className="subskill-progress-label">{translate("progress_subskill_preworkTitle")}</div>
                      :
                        <div className="subskill-progress-label">Activities</div>
                      }
                      <div className="subskill-progress-bar">
                        <ProgressBar progressPercentage = { courseUnit.perUnitExercisePercentage ? parseInt(courseUnit.perUnitExercisePercentage?.split('%')[0]) : 0 }></ProgressBar>                                           
                      </div>
                      <div className="unit-details-progress">
                        { courseUnit.perUnitExercisePercentage } { courseUnit.perUnitExerciseDetails }
                      </div>
                    </div>
                    { sessionCard ?
                      <div>
                        <div>{translate("progress_subskill_sessionTitle")}</div>
                        { courseUnit?.perUnitcompletedSession === 1  && courseUnit?.sessionStartTime ? 
                          <div>
                            <div className="session-text-completed">{translate("progress_subskill_sessionStatusCompleted")}</div>
                            <div className="session-text-starttime">{courseUnit?.sessionStartTime}</div>
                          </div>
                        : 
                          <div className="session-text-completed">NOT STARTED</div>
                        }
                      </div>
                    :
                      ""
                    }
                  </div>                                                
                </div>
              </div>
            </CardContent>
          </Card>
        }
        </>
      }
    </React.Fragment>
  );
};

export default ProgressCard;
